import React from 'react'
import styled from 'styled-components'
import { Col, Row, Image, Container } from '../components'
import { useTranslation } from 'react-i18next'

const Text = styled.p`
  font-weight: 300;
  font-size: 20px;
  color: #363535;

  @media (max-width: 768px) {
    font-size: 16px;
    margin: 10px 15px;
  }
`

const Title = styled.p`
  font-weight: 400;
  font-size: 40px;
  color: #363535;
  margin: 15px 25px;

  @media (max-width: 768px) {
    font-size: 24px;
    margin: 10px 15px;
  }
`

const StyledRow = styled(Row)`
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`

const StyledCol = styled(Col)`
  flex: 1;
  margin: 10px;

  @media (max-width: 768px) {
    align-items: center;
  }
`

const History = () => {
  const { t } = useTranslation()
  return (
    <Container id="history">
      <Image
        wid="250px"
        height="250px"
        img1={require('assets/second.jpg')}
        img2={require('assets/line2.jpg')}
        img3={require('assets/boom.jpg')}
      />
        <StyledRow>
          <StyledCol>
            <Title>{t('history.title')}</Title>
            <Text>{t('history.content1')}</Text>
            <Text>{t('history.content2')}</Text>
            <Text>{t('history.content3')}</Text>
          </StyledCol>

          <StyledCol>
            <Text>{t('history.content4')}</Text>
            <Text>{t('history.content5')}</Text>
            <Text>{t('history.content6')}</Text>
          </StyledCol>
        </StyledRow>
    </Container>
  )
}

export default History